// https://github.com/moment/moment/tree/develop/locale
export const momentLocalizationMap = {
  en: "en",
  "cs-CZ": "cs",
  "de-DE": "de",
  "es-ES": "es",
  "fr-FR": "fr",
  "hr-HR": "hr",
  "it-IT": "it",
  "lt-LT": "lt",
  "hu-HU": "hu",
  "nl-NL": "nl",
  "pl-PL": "pl",
  "pt-PT": "pt",
  "pt-BR": "pt-br",
  "ro-RO": "ro",
  "sk-SK": "sk",
  "sv-SE": "sv",
  "tr-TR": "tr",
  "ru-RU": "ru",
  "sr-RS": "sr-cyrl",
  "ja-JP": "ja",
  "zh-CN": "zh-cn",
};
